type IconProps = React.ComponentProps<'svg'>

export function CurrencyDollarIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(5, 1)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 0c0.55228 0 1 0.44772 1 1l0 1 1 0c2.76142 0 5 2.23858 5 5 0 0.55228-0.44772 1-1 1-0.55228 0-1-0.44772-1-1 0-1.65685-1.34315-3-3-3l-1 0 0 6 1 0c2.76142 0 5 2.23858 5 5 0 2.76142-2.23858 5-5 5l-1 0 0 1c0 0.55228-0.44772 1-1 1-0.55228 0-1-0.44772-1-1l0-1-1 0c-2.76142 0-5-2.23858-5-5 0-0.55228 0.44772-1 1-1 0.55228 0 1 0.44772 1 1 0 1.65686 1.34315 3 3 3l1 0 0-6-1 0c-2.76142 0-5-2.23858-5-5 0-2.76142 2.23858-5 5-5l1 0 0-1c0-0.55228 0.44772-1 1-1z m1 18l1 0c1.65685 0 3-1.34315 3-3 0-1.65685-1.34315-3-3-3l-1 0 0 6z m-3-14c-1.65685 0-3 1.34315-3 3 0 1.65685 1.34315 3 3 3l1 0 0-6-1 0z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
